<template>
	<div class="outer">
		<div class="middle">
			<div class="inner text-center">
				<font-awesome-icon
					class="active-color "
					icon="map-marker-alt"
					size="4x"
				/>
				<h2>Welcome to the Solar PV Forecasting Tool</h2>
				<p id="import-locs-text">
					Start creating your own list of PV systems by clicking the Map or
					importing your locations table (<a
						href="/Import-example.csv"
						target="_blank"
						>check template</a
					>)
				</p>
				<ImportButton
					style="width: 250px;"
					class="margin-center"
					:error_callback="update_alert"
				/>
				<div v-if="alert" class="clear p-t">
					<div class="alert">
						<div>
							<span>An error occurred: </span>
							<span>{{ alert }}</span>
							<div class="alert-close" v-on:click="alert = undefined">
								<font-awesome-icon
									style="cursor:pointer"
									size="lg"
									icon="times"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import ImportButton from "@/components/new-location/ImportButton";

export default {
	name: "ImportNewLocs",
	components: {
		ImportButton
	},
	data: function() {
		return {
			alert: undefined
		};
	},
	methods: {
		update_alert: function(error) {
			this.alert = error;
		}
	}
};
</script>

<style>
#home-import-text {
	font-size: 16px;
	line-height: 1.5;
	margin: 15px 0 0;
}
.outer {
	display: table;
	position: absolute;
	top: 0;
	left: 0;
	height: 100%;
	width: 100%;
}

.middle {
	display: table-cell;
	vertical-align: middle;
}

.inner {
	margin-left: auto;
	margin-right: auto;
	width: 95%;
}
#import-locs-text {
	font-size: 16px;
	line-height: 1.5;
}
</style>
